<header-title [model]="headerTitle"></header-title>

<div class="tabs">
    <ul class="nav nav-tabs">
        <li [ngClass]="{'nav-item' : true, 'active' : selectedTab==1}" (click)="selectedTab=1">
            <a class="nav-link" href="#audits" data-toggle="tab"> Audits</a>
        </li>
        <li [ngClass]="{'nav-item' : true, 'active' : selectedTab==2}" (click)="selectedTab=2">
            <a class="nav-link" href="#audittypes" data-toggle="tab"> Audit Types</a>
        </li>
    </ul>
    <div class="tab-content">
        <div id="audits" [ngClass]="{'tab-pane' : true, 'active' : selectedTab==1}">
            <app-company-audit-list [companyId]="companyId"></app-company-audit-list>
        </div>
        <div id="audittypes" [ngClass]="{'tab-pane' : true, 'active' : selectedTab==2}">
            <app-company-audit-type-list [companyId]="companyId"></app-company-audit-type-list>
        </div>
    </div>
</div>
